import t from 'vivino-js/translationString';
import { DrinkingWindow } from 'vivino-ui/icons/WineFacts';

const TRANSLATION_PATH = 'components.shared.wine_summary';
const TRANSLATIONS = {
  bestEnjoyedBetween: `${TRANSLATION_PATH}.best_enjoyed_between`,
  drinkingWindow: `${TRANSLATION_PATH}.drinking_window`,
  fromNow: `${TRANSLATION_PATH}.from_now`,
};

export const getDrinkingWindowFact = (vintage, translationFunc = t) => {
  const wineFacts = vintage?.wine_facts || {};
  const drinkFrom = wineFacts.drink_from || '';
  const drinkUntil = wineFacts.drink_until || '';
  if (!drinkFrom && !drinkUntil) {
    return null;
  }
  return {
    key: 'drinkingWindow',
    headerLabel: translationFunc(TRANSLATIONS.bestEnjoyedBetween),
    icon: DrinkingWindow,
    values: [
      {
        name: translationFunc(TRANSLATIONS.drinkingWindow, {
          drinkFrom: drinkFrom || translationFunc(TRANSLATIONS.fromNow),
          drinkUntil,
        }).trim(),
      },
    ],
  };
};
